var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeclineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 33C25.6127 33 33 25.6127 33 16.5C33 7.3873 25.6127 0 16.5 0C7.3873 0 0 7.3873 0 16.5C0 25.6127 7.3873 33 16.5 33Z",
    fill: "#F03B38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8831 10.8003L11.2945 10.4551C11.9903 9.87131 12.9319 10.2795 14.112 11.6859C14.1644 11.642 15.0535 12.4129 16.7644 14.0113L19.4351 11.7704C21.3802 10.1383 22.6038 9.62148 23.0997 10.2125L23.5209 10.5474C24.3809 11.5723 23.9902 12.869 22.3563 14.4312C22.0561 14.7724 21.6249 15.1852 21.0488 15.6685L19.5078 16.9616C21.0261 18.5432 22.0765 19.6887 22.6603 20.3845C23.9785 21.9554 24.2561 23.0611 23.5005 23.6951C22.2063 24.781 19.9674 23.4345 16.7911 19.6491L16.7088 19.7182C15.8475 20.5301 15.1769 21.1438 14.6757 21.5644L14.5111 21.7025C12.409 23.4664 11.2663 24.2467 11.0843 24.0298C10.3671 23.8284 9.81336 23.5027 9.443 23.0613C8.58302 22.0364 9.82561 20.1142 13.1696 17.3082L13.8204 16.7621C13.1592 16.0804 12.671 15.5594 12.376 15.2078L11.221 13.8313C10.3955 12.65 10.1662 11.7843 10.5482 11.2216C10.594 11.0939 10.7035 10.951 10.8831 10.8003Z",
    fill: "#FAF6F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeclineIcon);
export default __webpack_public_path__ + "static/media/decline_icon.c1a031530c396d27b0e15b12a197c096.svg";
export { ForwardRef as ReactComponent };